import PropTypes from 'prop-types'
import React from 'react'

import { Row, Left, Right } from 'components/BusinessCard/components/StyledComponents'
import Highlighter from 'components/BusinessCard/components/Highlighter'
import { useBusinessCard } from 'components/BusinessCard/context'

const PhoneNumber = ({ label, number, type }) => {
  const { cardMeta: { highlighter }, resource, resourceType, resourceId } = useBusinessCard()

  // Build data attributes for contact info (used by global tel: handler)
  const getDataAttributes = () => {
    if (resourceType === 'Person') {
      return {
        'data-contact-name': resource?.full_name || resource?.name,
        'data-person-id': resourceId,
        'data-company-id': resource?.company_id
      }
    }
    if (resourceType === 'Company') {
      return {
        'data-contact-name': resource?.name,
        'data-company-id': resourceId
      }
    }
    return {}
  }

  return (
    <Row>
      {label &&
        <Left>
          <span className="title">{label}</span>
        </Left>}
      <Right>
        <a href={`tel:${number}`} data-cypress="phone-number-link" {...getDataAttributes()}><Highlighter term={highlighter}>{number}</Highlighter></a>
      </Right>
    </Row>
  )
}

PhoneNumber.propTypes = {
  label: PropTypes.string,
  number: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
}

export default PhoneNumber
